import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Fast bring recipe importer", -1)

import RecipeBuilder from '@/components/RecipeBuilder.vue'
import { computed, ref } from 'vue'
import { Recipe } from 'fabri-core'
import LinkImportSource from '@/components/LinkImportSource.vue'
import QRImportSource from '@/components/QRImportSource.vue'
import NFCImportSource from '@/components/NFCImportSource.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const currentRecipe = ref<Recipe>({
  name: '',
  ingredients: []
})

// TODO: marmer 25.02.2022 App Icon

// TODO: marmer 25.02.2022 Add description what this page is, before recipe has been entered
// TODO: marmer 25.02.2022 add styles
// TODO: marmer 25.02.2022 explain why importing only works with the singular of german ingredients (e.g. Erdbeere 1kg works. Erdbeeree 1kg does remove the weight)
// TODO: marmer 25.02.2022 Ad ability to change servings
// TODO: marmer 01.03.2022 Optional image-url for the imported recipe

const recipeImporable = computed(() => currentRecipe.value.name && currentRecipe.value.ingredients?.length)

const updateRecipe = (recipe: Recipe) => {
  currentRecipe.value = {
    ...recipe,
    ingredients: [...recipe.ingredients]
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_unref(recipeImporable))
      ? (_openBlock(), _createBlock(LinkImportSource, {
          key: 0,
          recipe: currentRecipe.value
        }, null, 8, ["recipe"]))
      : _createCommentVNode("", true),
    _createVNode(RecipeBuilder, { onRecipeChanged: updateRecipe }),
    (_unref(recipeImporable))
      ? (_openBlock(), _createBlock(QRImportSource, {
          key: 1,
          recipe: currentRecipe.value
        }, null, 8, ["recipe"]))
      : _createCommentVNode("", true),
    (_unref(recipeImporable))
      ? (_openBlock(), _createBlock(NFCImportSource, { key: 2 }))
      : _createCommentVNode("", true)
  ]))
}
}

})